import axios from 'axios';

import { Field } from '@components/form/dynamic-fields';
import { FormAnswers, FormListsMap, FormV2 } from '@components/form/v2';

const VERSION = 'v1';

export const request = axios.create({
  baseURL: `${process.env.VITE_API_URL}/${VERSION}/`,
});

export type ApplicationData = {
  name: string;
  ssn: string | null;
};

export type JourneyFormResponse = {
  uuid: string;
  journeyUuid: string;
  fieldsConfig: FormV2;
  lists: FormListsMap;
  submissionMessageConfig: FormV2;
  hasPublishedJourney: boolean;
  isClosed: boolean;
  closeReason: 'deadline_passed' | 'response_limit_reached' | null;
  closedHeading: string | null;
  closedMessage: string | null;
};

export type FormResponse =
  | {
      fieldsConfig: Field[];
      lists: FormListsMap;
      submissionMessageConfig: FormV2;
      formAnswers: FormAnswers;
    }
  | {
      fieldsConfig: FormV2;
      lists: FormListsMap;
      formAnswers: FormAnswers;
      submissionMessageConfig: FormV2;
    };

export const loadForm = async (uuid: string) => {
  const response = await request.get<FormResponse>(`forms/public/${uuid}/`);
  return response.data;
};

export const loadJourneyForm = async (journeyUuid: string, formUuid: string) => {
  const response = await request.get<JourneyFormResponse>(
    `journey-forms/public/${journeyUuid}/${formUuid}/`,
  );
  return response.data;
};

export const loadJourneyFormBySlug = async (companySlug: string, formSlug: string) => {
  const response = await request.get<JourneyFormResponse>(
    `journey-forms/public/by-slug/${companySlug}/${formSlug}/`,
  );
  return response.data;
};

export type SaveFormResponse = {
  isComplete: boolean;
  uuid: string;
  fieldsConfig: any;
  submissionMessageConfig: any;
};

export const saveForm = async (uuid: string, formData: FormData) => {
  return request.patch<SaveFormResponse>(`forms/public/${uuid}/`, formData);
};

export const saveJourneyForm = async (
  journeyUuid: string,
  formUuid: string,
  formData: FormData,
) => {
  return request.post<SaveFormResponse>(
    `journey-forms/public/${journeyUuid}/${formUuid}/`,
    formData,
  );
};
